/**
 * safeJson — intenta parsear la respuesta como JSON.
 * Si falla (ej: respuesta HTML de error 500), retorna null.
 */
export async function safeJson(response) {
  try {
    const text = await response.text();
    if (!text || text.trimStart().startsWith('<')) return null;
    return JSON.parse(text);
  } catch {
    return null;
  }
}

/**
 * friendlyError — convierte un objeto de error de DRF o una respuesta fallida
 * en un mensaje legible para el usuario.
 *
 * @param {Response} response  — fetch Response
 * @param {string}   fallback  — mensaje por defecto si no se puede extraer
 */
export async function friendlyError(response, fallback = 'Ocurrió un error inesperado') {
  const json = await safeJson(response);
  if (!json) {
    // El servidor devolvió HTML (error 500, nginx error, etc.)
    const codes = { 500: 'Error interno del servidor', 502: 'Servidor no disponible',
                    503: 'Servicio temporalmente no disponible', 404: 'Recurso no encontrado' };
    return codes[response.status] || fallback;
  }

  // DRF puede devolver: { detail }, { non_field_errors }, { campo: ["msg"] }, { error }
  if (typeof json === 'string') return json;
  if (json.detail)           return json.detail;
  if (json.error)            return json.error;
  if (json.non_field_errors) return json.non_field_errors[0];

  // Errores por campo: { nombre: ["Este campo es requerido."] }
  const entries = Object.entries(json);
  if (entries.length > 0) {
    const [field, msgs] = entries[0];
    const msg = Array.isArray(msgs) ? msgs[0] : msgs;
    return `${field}: ${msg}`;
  }

  return fallback;
}
